import React from 'react'
import effects from 'app/effects/effects'
import ApiPicturesPanel from './ApiPicturesPanel'
import { panelParseResponse } from 'libs/PagingParser'
import { FormattedMessage, useIntl } from 'react-intl'
import { itemMapper } from './ItemMapper'
import EmptyContent from 'app/components/empty/EmptyContent'
import { Routes } from 'app/services/routeService/routeService'
import { withRouter } from 'react-router-dom'

const SUMMARY_COUNT = 8
const apiFetcher = () =>
  effects.apis
    .recentSubscribers({ page: 1, limit: SUMMARY_COUNT })
    .then(panelParseResponse(itemMapper))

const SubscribersPanel = ({ history, ...rest }) => {
  const { formatMessage } = useIntl()
  return (
    <ApiPicturesPanel
      ApiPanelProp={{
        title: formatMessage({ id: 'subscriber.recentSubscribers.label' }),
        link: Routes.subscribersV4(),
        apiFetcher,
        onItemClick: (item) =>
          history.push(Routes.viewSubscriberDetail(item.id)),
        withCrmField: true,
        subscribersPageSection: rest.subscribersPageSection ? true : false,
      }}
      emptyContent={
        <EmptyContent
          linkProp={{ to: Routes.subscribersV4() }}
          linkLabel={<FormattedMessage id="empty.subscriber.link" />}
          descriptionLabel={
            <FormattedMessage id="empty.subscriber.youDontHaveAnySubscribers" />
          }
        />
      }
    />
  )
}

export default withRouter(SubscribersPanel)
